/**
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define(["dojo/_base/lang"], function (lang) {
    /**
     * @description A util for mixin dijit lifecycle method into an object
     * If an object is a dijit or widget inherited from dijit/_WidgetBase, then
     * assign the dijit/_WidgetBase lifecycle methods to the wrapper; If not, assign
     * methods with no-op function to the wrapper.
     * Calling the methods of the wrapper will invoke the methods with same names in widget or
     * dijit.
     * @param {Object} [wrapper] - wrapper of the widget or dijit.
     * @param {Object} [obj = wrapper.widget] - The widget or dijit object. By default, it's
     * wrapper.widget
     */
    return (wrapper, obj = wrapper.widget) => {
        let emptyFunc = () => {};

        if (lang.isFunction(obj.startup)) {
            wrapper.startup = () => {
                obj.startup();
            };
        } else {
            wrapper.startup = emptyFunc;
        }

        if (lang.isFunction(obj.destroyRecursive)) {
            wrapper.destroyRecursive = (/*Boolean?*/ preserveDom) => {
                obj.destroyRecursive(preserveDom);
            };
        } else {
            wrapper.destroyRecursive = emptyFunc;
        }

        if (lang.isFunction(obj.destroy)) {
            wrapper.destroy = (/*Boolean?*/ preserveDom) => {
                obj.destroy(preserveDom);
            };
        } else {
            wrapper.destroy = emptyFunc;
        }
    };
});